// extracted by css-extract-rspack-plugin
export default {"loading":"uvOTIb","hidden":"xAdRBZ","pulse":"KZE4_F"};